// extracted by mini-css-extract-plugin
export var image = "W_dp";